import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { withLocalize } from 'react-localize-redux';
import TopbarService from '../../services/topbar';
import TopbarMenu from './TopbarMenu';
import { getUserData } from '../../selectors/user';
import toaster from '../../utils/toaster';
import { HEADERS, LANGUAGE_CHANGED_EVENT, SUPPORTED_LANGUAGES } from '../consts';
import css from '../style.css';

const topbarService = new TopbarService();

const resolveLanguageCode = code => (SUPPORTED_LANGUAGES.some(lang => lang.code === code) ? code : 'en');

function LanguageSelector({ translate }) {
    const userData = useSelector(getUserData) || {};
    const [currentCode, setCurrentCode] = useState(() => resolveLanguageCode(userData.preferred_language));

    useEffect(() => {
        const onLanguageChanged = event => setCurrentCode(resolveLanguageCode(event.detail?.code));
        window.addEventListener(LANGUAGE_CHANGED_EVENT, onLanguageChanged);
        return () => window.removeEventListener(LANGUAGE_CHANGED_EVENT, onLanguageChanged);
    }, []);

    const currentLanguage = SUPPORTED_LANGUAGES.find(lang => lang.code === currentCode) || SUPPORTED_LANGUAGES[0];

    const changeLanguage = code => {
        setCurrentCode(code);
        topbarService.setLanguage(code).catch(() => toaster.error(translate(`${HEADERS}.LANGUAGE_SAVE_ERROR`)));
        window.dispatchEvent(new CustomEvent(LANGUAGE_CHANGED_EVENT, { detail: { code } }));
    };

    return (
        <TopbarMenu ariaLabel="language selector" toggle={<i className={currentLanguage.icon} />}>
            {SUPPORTED_LANGUAGES.map(lang => (
                <button
                    type="button"
                    key={lang.code}
                    className={css.menuItem}
                    onClick={() => changeLanguage(lang.code)}
                >
                    <i className={lang.icon} /> <span>{lang.displayName}</span>
                </button>
            ))}
        </TopbarMenu>
    );
}

LanguageSelector.propTypes = {
    translate: PropTypes.func.isRequired,
};

export default withLocalize(LanguageSelector);
